module.exports = {
  FocusedImage: require("./lib/focused_image")
};
